module.exports = {
  "wxc-loading": {
    "position": "fixed",
    "left": 287,
    "top": 500,
    "zIndex": 9999
  },
  "loading-box": {
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": 20,
    "width": 175,
    "height": 175,
    "backgroundColor": "rgba(0,0,0,0.8)"
  },
  "trip-loading": {
    "backgroundColor": "rgba(0,0,0,0.2)"
  },
  "loading-trip-image": {
    "height": 75,
    "width": 75
  },
  "loading-text": {
    "color": "#ffffff",
    "fontSize": 24,
    "lineHeight": 30,
    "height": 30,
    "marginTop": 8,
    "textOverflow": "ellipsis",
    "width": 140,
    "textAlign": "center"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-f43c7080!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-loading/index.vue
// module id = 163
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28